"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Vauxhall = function Vauxhall(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M24.007 12c0 6.627-5.372 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-15 8.684a10.346 10.346 0 0 1-.744-2.33c-.342-.055-.937-.174-1.464-.401-.25-.108-.592-.207-.532-.116.067.102.149.158.198.231.056.086-.538-.043-.99-.358-.388-.272-.514-.349-.953-.187a3.365 3.365 0 0 0-.553.27 10.004 10.004 0 0 0 4.39 3.373l.647-.482zm4.41-13.104c.055.03.359.182.55.27.19.087.328.066.38.045.05-.021.22-.148.358-.264.094-.077.042-.099-.102-.163a2.764 2.764 0 0 0-.794-.2h-.026c-.072 0-.148.03-.302.148-.075.059-.162.109-.064.164zm6.273 3.183c-.028-4.617-4.328-7.777-9.365-6.833-.9.169-1.575.28-.03-.677.951-.59 2.217-.983 3.437-1.067a10.122 10.122 0 0 0-1.701-.144c-5.514 0-9.984 4.436-9.984 9.908 0 .825.103 1.627.295 2.394.31-.109.506-.155.506-.155a9.489 9.489 0 0 1 .134-4.764l-.002.007.004-.014a9.392 9.392 0 0 1 1.799-3.387l5.293-.002-2.08 3.68H3.902a8.65 8.65 0 0 0-.063 4.584c.022.043.46.865 1.927.86.235-.002.91-.007 2.137-.03a.264.264 0 0 0 .203-.096.433.433 0 0 0 .09-.234c.022-.164.045-.32.005-.39-.053-.09-.203-.069-.535.16-.233.16-.319.089-.316-.11-.009-.264.159-.807.466-1.59.14-.358.352-.858.383-.936.172-.43.362-.627.053-.512-.632.235.439-1.261 1.063-2.006.29-.346.596-.6.28-.546-.479.08.745-1.063 1.258-1.391.345-.222.498-.368.65-.526.458-.482.517-.629.898-1.029.376-.393.638-.564.761-.564.095 0 .108.1.03.278-.369.83-.494 1.36 1.284 1.254.97-.059.91.727.912.727 2.614.121 1.166 2.35 1.161 2.337-.26-.811-1.16-.766-1.77-.675-.536.079-.095.17.065.223.997.333.798.698.71.68-1.37-.27-1.757.47-1.759 1.186-.006 2.14 1.019 4.17 2.688 4.774 1.863-.786 3.225-2.302 3.207-5.374zM5.654 6.856c.052.26.426 1.947.468 2.121.046.196.085.286.254.286h.904c.145 0 .187-.032.268-.172.132-.23 1.315-2.266 1.315-2.266s.127-.199-.152-.199h-.543c-.046 0-.094.024-.126.08a536.81 536.81 0 0 0-1.104 1.962l-.399-1.914s-.008-.128-.163-.128l-.537-.001c-.11.001-.227.02-.185.231z"
  }));
};

Vauxhall.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Vauxhall.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Vauxhall;
exports.default = _default;